import {BannerCfg} from '../config/BannerCfg';

import type {IBannerRequestResult} from './IBannerTransport'; 

export class BannerRequestId {
    private bannerCfg: BannerCfg | undefined;
    private result: IBannerRequestResult;

    id: string;
    bannerPlace: string;
    container: HTMLElement;
    slot: string;
    transport = 'js_adq';

    constructor(id: string, bannerPlace: string, slot: string, container: HTMLElement) {
        this.id = id;
        this.bannerPlace = bannerPlace;
        this.container = container;
        this.slot = slot;
    }

    getBannerCfg(): BannerCfg {
        if (!this.bannerCfg) {
            this.bannerCfg = new BannerCfg();
        }
        return this.bannerCfg;
    }

    setBannerCfg(bannerCfg: BannerCfg): this {
        this.bannerCfg = bannerCfg;
        return this;
    }

    getResult(): IBannerRequestResult {
        return this.result;
    }

    setResult(result: IBannerRequestResult): this {
        this.result = result;
        return this;
    }

    setTransport(transport: string) {
        this.transport = transport;
        return this;
    }

    toString() {
        return 'BannerRequestId{' +
            'id=\'' + this.id + '\'' +
            ', bannerPlace=\'' + this.bannerPlace + '\'' +
            ', slot=' + this.slot +
            ', transport=\'' + this.transport + '\'' +
            '}';
    }
}
